import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function lerb() {
  // HOOKS
  const { doGet, setup } = useBackend()

  // https://dev-api3.sanitas.com/claims-lerb-service/v1/lerb/search
  // INIT
  setup('/claims-lerb-service/v1', config.microserviceBaseUrl)

  // METHODS
  async function searchCareProviders({ avmNetwork, fullName, newPatientStatus, searchDate, size, zipCode }) {
    const response = await doGet({
      url: '/lerbs/search',
      params: {
        avmNetwork,
        fullName,
        newPatientStatus,
        plz: zipCode,
        searchDate,
        size,
      }
    })

    return response
  }

  async function searchCareProvidersByArea({ avmNetwork, coordinates, fullName, newPatientStatus, searchDate, size }) {
    const response = await doGet({
      url: '/lerbs/search/area',
      params: {
        avmNetwork,
        fullName,
        minLatitude: coordinates.minLatitude,
        maxLatitude: coordinates.maxLatitude,
        minLongitude: coordinates.minLongitude,
        maxLongitude: coordinates.maxLongitude,
        newPatientStatus,
        searchDate,
        size,
      }
    })

    return response
  }


  return {
    searchCareProviders,
    searchCareProvidersByArea,
  }
}

export default lerb()
